The identifier for the `PositionNotPostedReason`.
